export const VerificationRoute = {
  Verification: (): string => '/profile/verification/credentials',
};
